<template>
	<div>
		<template v-if="invalidPage">
			<div class="catalog-empty" :style="`background-color: ${theme.base}; color: ${theme.secondary}`">
				<div class="catalog-empty-message">
					<p>Lo sentimos  :(</p>
					<p>La página a la que intentas acceder no existe</p>
				</div>
			</div>
		</template>
		<template v-else>
			<catalog-header
				:attention="attention"
				:commerce="commerce"
				:open="open"
				:search="search"
				:theme="theme"
				@open-search="openSearch"
				@search-data="searchData"
				@set-data="setData"
			></catalog-header>
			<div class="content-block">
				<div class="app-container container-categories">
					<catalog-categories
						:amount-min="priceMin"
						:categories="categories"
						:currency-symbol="currencySymbol"
						:show-amount-min="showAmountMin"
						:theme="theme"
						@select-category="selectCategory"
					></catalog-categories>
				</div>
				<!-- <div class="app-container container-catalog" v-scroll="onScroll"> -->
				<div class="app-container container-catalog" :class="{ 'container-catalog-min': priceMin }" v-scroll="onScroll">
					<div class="catalog-column catalog-column-left">
						<catalog-products
							:loading="loadingProducts"
							:currency="currencySymbol"
							:products="products"
							:theme="theme"
							@add-product="addProduct"
							@add-quantity="addQuantity"
							@change-value="changeValue"
							@open-gallery="openGallery"
							@sub-quantity="subQuantity"
						></catalog-products>
						<!-- <catalog-products
							:loading="loadingProducts"
							:currency="currencySymbol"
							:products="products"
							@add-product="addProduct"
							@add-quantity="addQuantity"
							@on-scroll="onScroll"
							@open-gallery="openGallery"
							@sub-quantity="subQuantity"
						></catalog-products> -->
					</div>
					<div class="catalog-column catalog-column-right">
						<catalog-sidebar
							:amount-min="priceMin"
							:currency="currencySymbol"
							:delivery="delivery"
							:delivery-type="commerce.deliveryType"
							:disabled="disabled"
							:form="form"
							:gps-selected="gpsSelected"
							:facebook-message="facebookMessage"
							:loading="loading"
							:payment-methods="commerce.wayPaymentCommerce"
							:pickup-selected="pickupSelected"
							:products-selected="completeProducts.filter(p => p.isSelected)"
							:quantity="totalQuantity"
							:show-amount-min="showAmountMin"
							:subtotal="subtotal"
							:theme="theme"
							:total="total"
							:whatsapp-link="whatsappLink"
							:whatsapp-link-share="whatsappLinkShare"
							:whatsapp-message="whatsappMessage"
							:whatsapp-share-message="whatsappShareMessage"
							@delete-product="deleteProduct"
							@get-field-data="setData"
							@get-shipping-type="setShippingType"
							@send-whatsapp="createPreOrder"
						></catalog-sidebar>
					</div>
				</div>
			</div>
			<catalog-footer
				:currency="currencySymbol"
				:quantity="totalQuantity"
				:theme="theme"
				:total="total"
			></catalog-footer>
			<catalog-dialog
				v-if="dialog.open"
				:description="dialog.description"
				:images="dialog.data"
				:theme="theme"
				:title="dialog.title"
				@close-gallery="closeGallery"
			></catalog-dialog>
			<catalog-dialog-options
				v-if="showAppOption"
				:commerce-name="commerce.name"
				:theme="theme"
				@stay="stayHere"
				@go-to-app="goToApp"
			></catalog-dialog-options>
		</template>
	</div>
</template>

<script>
	import { format, getDay } from 'date-fns';
	import catalogCategories from '@/components/catalog/catalog-categories';
	import catalogDialog from '@/components/catalog/catalog-dialog';
	import catalogDialogOptions from '@/components/catalog/catalog-dialog-options';
	import catalogFooter from '@/components/catalog/catalog-footer';
	import catalogHeader from '@/components/catalog/catalog-header';
	import catalogProducts from '@/components/catalog/catalog-products';
	import catalogSidebar from '@/components/catalog/catalog-sidebar';

	const CLOSE_LABEL = 'CERRADO';
	const OPEN_LABEL = 'ABIERTO';

	function created() {
		const theme = process.env.CATALOG_COLORS.split(', ');
		this.theme = theme.reduce((a, t) => {
			const newA = { ...a };
			const item = t.split(': ');
			const prop = item[0];
			const value = item[1];
			newA[prop] = `#${value}`;
			return newA;
		}, {});
		this.loadCommerce();
	}

	function addProduct(product) {
		this.$set(product, 'isSelected', true);
	}

	function addQuantity(product) {
		const qtyRounded = Number((product.quantity).toFixed());
		const qty = qtyRounded > product.quantity ? qtyRounded : qtyRounded + 1;
		const isSelected = qty > 0;
		this.setNewPrice(product, qty);
		this.$set(product, 'quantity', qty);
		this.$set(product, 'isSelected', isSelected);
	}

	function buildWhatsappMessage() {
		const productsSelected = this.completeProducts.filter(p => p.isSelected);
		const productsInline = productsSelected.reduce((a, p) => {
			const inline = `${p.quantity} ${p.unitCode} de ${p.name}......${this.currencySymbol}${p.price.toFixed(2)} c/u\n`;
			const newA = a.concat(inline);
			return newA;
		}, '');
		const shippingTypeSelected = this.gpsSelected ?
			`Envío a domicilio (https://google.com/maps/dir//${this.latitude},${this.longitude})` :
			'Recojo en tienda';
		const shippingType = this.gpsSelected || this.pickupSelected ? shippingTypeSelected :
			'No indicado';
		const message = `¡Hola! 👋  tienes un nuevo pedido 🛒 \n\n ============================== \nNombre: ${this.form.name}\nTeléfono: ${this.form.phone}\nDirección: ${this.form.address}\nMétodo de pago: ${this.form.paymentMethod}\nTipo de entrega: ${shippingType}\nInformación adicional: ${this.form.additionalInformation}\n ============================= \n\n 🛍 Productos:\n${productsInline} \n\n *TOTAL DE PEDIDO: ${this.currencySymbol}${this.total.toFixed(2)}*`;
		return message;
	}

	function changeCategory(id) {
		this.loadingProducts = true;
		const productsWithCategories = this.completeProducts.filter(cp => cp.comCategories &&
			cp.comCategories.length > 0);
		if (id > 0) {
			this.products = productsWithCategories.length > 0 ?
				productsWithCategories.filter(cp => cp.comCategories.find(c => c.id === id)) : [];
			this.loadingProducts = false;
		} else {
			this.products = [...this.completeProducts];
			this.loadingProducts = false;
		}
	}

	function changeValue({ btnData, product }) {
		const { target } = btnData;
		const qty = Number(target.valueAsNumber.toFixed(1));
		const newQty = qty < 0 ? 0 : qty;
		target.value = newQty;
		const isSelected = newQty > 0;
		this.$set(product, 'quantity', newQty);
		this.$set(product, 'isSelected', isSelected);
	}

	function clearCar() {
		this.categories = this.categories.map((cat, index) => {
			const newCategory = { ...cat };
			newCategory.isSelected = index === 0;
			return newCategory;
		});
		this.completeProducts = this.completeProducts.map((cp) => {
			const newProduct = { ...cp };
			newProduct.isSelected = false;
			newProduct.quantity = 0;
			newProduct.unitCode = cp.unit ? cp.unit.code : 'UND';
			newProduct.unitName = cp.unit ? cp.unit.name : 'UNIDAD';
			return newProduct;
		});
		this.products = [...this.completeProducts];
		this.loading = false;
	}

	function closeGallery() {
		this.dialog.open = false;
		this.dialog.data = null;
		this.dialog.description = '';
		this.dialog.title = '';
		const body = document.getElementById('body');
		body.style = '';
	}

	async function createPreOrder() {
		this.loading = true;
		const headersAuth = { Authorization: `Bearer ${process.env.TOKEN_CATALOG}` };
		const productsSelected = this.products.filter(p => p.isSelected);
		const body = {
			order: {
				orderCode: 0,
				customer: {},
				products: productsSelected.map(p => ({
					amount: (Number(p.price) * p.quantity),
					code: p.code,
					description: p.description,
					id: p.id,
					name: p.name,
					price: p.price,
					quantity: p.quantity,
					urlImage: p.urlImage,
					unitId: p.unitId,
					warehouseId: p.warehouseProduct ? p.warehouseProduct.id : null,
				})),
				makiId: null,
				origin: 'Web',
				status: 'Pendiente',
			},
			isNotLogged: true,
		};
		try {
			({ data: this.preOrder } = await this.$httpShoppyRunn.post('pre-order', body,
				{ headers: headersAuth }));
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.clearCar();
		}
	}

	function deleteProduct(product) {
		this.$set(product, 'quantity', 0);
		this.$set(product, 'isSelected', false);
	}

	function disabled() {
		const formKeys = Object.keys(this.form);
		const newPrice = this.total < this.priceMin;
		const finalValue = this.completeProducts.every(cp => !cp.isSelected) ||
			formKeys.some(fk => fk !== 'additionalInformation' && !this.form[fk]) || this.loading
			|| newPrice;
		if (!finalValue) {
			this.whatsappMessage = encodeURIComponent(this.buildWhatsappMessage());
		}
		return finalValue;
	}

	function getLocation() {
		this.loading = true;
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((response) => {
				this.location = { lat: response.coords.latitude, lng: response.coords.longitude };
				this.loading = this.latitude === 0 || this.longitude === 0;
			}, (objPositionError) => {
				switch (objPositionError.code) {
				case objPositionError.PERMISSION_DENIED:
					this.showNotification('No se ha permitido el acceso a la posición del usuario.', 'warning');
					this.loading = false;
					break;
				case objPositionError.POSITION_UNAVAILABLE:
					this.showNotification('No se ha podido acceder a la información de su posición.', 'warning');
					this.loading = false;
					break;
				case objPositionError.TIMEOUT:
					this.showNotification('El servicio ha tardado demasiado tiempo en responder.', 'warning');
					this.loading = false;
					break;
				default:
					this.showNotification('No se ha podido obtener la ubicación del usuario.', 'warning');
					this.loading = false;
				}
			}, { maximumAge: 75000, timeout: 15000, enableHighAccuracy: true });
		} else {
			this.showNotification('Su navegador no soporta la API de geolocalización.', 'warning');
			this.loading = false;
		}
	}

	function goToApp() {
		window.open(this.commerce.appLink, '_blank');
	}

	async function loadCategories() {
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		const params = { commerceId: this.commerce.id, assignedOnly: true };
		try {
			({ data: this.categories } = await this.$httpProducts.get('e-categories-public',
				{ headers, params }));
			this.categories = this.categories.map((cat) => {
				const newCategory = { ...cat };
				newCategory.isSelected = false;
				return newCategory;
			});
			this.categories.unshift({ id: 0, title: 'TODOS', isSelected: true });
			this.loadProducts();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function loadCommerce() {
		this.invalidPage = false;
		const domain = `${document.location.origin}${document.location.pathname}`;
		// const domain = 'https://casamarket.la/c/elmercader';
		// const domain = 'https://casamarket.la/c/pruebfer';
		const urlService = `${process.env.URL_SALES}/ecommerce-companies/public`;
		const body = { domain };
		try {
			({ data: this.commerce } = await this.$http.post(urlService, body));
			const wayPaymentCommerceSelected = this.commerce.wayPaymentCommerce[0] || {};
			this.form.paymentMethod = wayPaymentCommerceSelected.name;
			this.setCommerceData();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				this.invalidPage = true;
			}
		}
	}

	async function loadProducts(page = 1, categoryId) {
		this.page = page;
		const headersAuth = { Authorization: `Bearer ${this.token}` };
		const params = {
			flagCommerce: true,
			flagGrouper: 1,
			// limit: 20,
			// page: this.page,
			showCatalog: true,
		};
		const service = Number(this.totalRegisters) > this.completeProducts.length;
		if (service && categoryId >= 0) {
			params.categoryId = categoryId > 0 ? categoryId : null;
		}
		if (categoryId >= 0 && !service) {
			this.changeCategory(categoryId);
		} else {
			this.loadingProducts = true;
			try {
				const { data: products } = await this.$httpProducts.get(
					'products-public', { headers: headersAuth, params });
				// const { data: products, headers } = await this.$httpProducts.get(
				// 	'products-public', { headers: headersAuth, params });
				const newProducts = products.map((cp) => {
					const newProduct = { ...cp };
					newProduct.price = cp.priceList[this.priceListId] ?
						cp.priceList[this.priceListId].price || 0 : 0;
					newProduct.isSelected = false;
					newProduct.quantity = 0;
					newProduct.unitCode = cp.unit ? cp.unit.code : 'UND';
					newProduct.unitName = cp.unit ? cp.unit.name : 'UNIDAD';
					return newProduct;
				});
				this.completeProducts = this.completeProducts.concat(newProducts);
				this.products = [...this.completeProducts];
				// this.lastPage = Number(headers['x-last-page']);
				// this.totalRegisters = Number(headers['x-quantity']);
			} catch (err) {
				if (err.status === 500) {
					this.showGenericError();
				}
			} finally {
				this.loadingProducts = false;
			}
		}
	}

	function onScroll(scrollData) {
		const { path } = scrollData;
		if (path && path[1]) {
			const { scrollY } = path[1];
			const defaultValue = window.innerWidth >= 936 ? 2893 : 3400;
			const defaultVar = window.innerWidth >= 936 ? 387 : 196;
			const defaultTop = (defaultValue * this.page) + (defaultVar * (this.page - 1));
			if (scrollY === defaultTop && this.page < this.lastPage) {
				this.loadProducts(this.page + 1);
			}
		}
	}

	function openGallery(productData) {
		({
			description: this.dialog.description,
			name: this.dialog.title,
		} = productData);
		const { images, urlImage } = productData;
		this.dialog.data = images.length > 0 ? [...images] : [{ id: 1, urlImage }];
		this.dialog.open = true;
		const body = document.getElementById('body');
		body.style = 'left: 0px; overflow: hidden; position: fixed; width: 100%';
	}

	function openSearch() {
		this.open = !this.open;
		const btn = document.getElementsByClassName('catalog-header-content-searcher-input');
		btn[0].style = this.open ? 'display: initial' : '';
	}

	function searchData() {
		this.categories = this.categories.map((c, i) => {
			const newC = { ...c };
			newC.isSelected = i === 0;
			return newC;
		});
		this.products = this.search ? this.completeProducts.filter(cp =>
			cp.description.toLowerCase().includes(this.search.toLowerCase()) ||
			cp.name.toLowerCase().includes(this.search.toLowerCase())) :
			[...this.completeProducts];
	}

	function selectCategory({ id }) {
		this.categories = this.categories.map((cat) => {
			const newCat = { ...cat };
			newCat.isSelected = id === cat.id;
			return newCat;
		});
		this.loadProducts(1, id);
	}

	function setAttention({ hourFrom, hourTo }) {
		if (hourFrom && hourTo) {
			const actualHour = format(new Date(), 'HH:mm');
			const actualHourSplit = actualHour.split(':');
			const fromSplit = hourFrom.split(':');
			const toSplit = hourTo.split(':');
			const validComplete = this.validAttention(
				Number(actualHourSplit[0]),
				Number(actualHourSplit[1]),
				Number(fromSplit[0]),
				Number(fromSplit[1]),
				Number(toSplit[0]),
				Number(toSplit[1]),
			);
			this.attention.label = validComplete ? OPEN_LABEL : CLOSE_LABEL;
			this.attention.color = validComplete ? this.theme.accent : this.theme.error;
		} else {
			this.attention.label = CLOSE_LABEL;
			this.attention.color = this.theme.error;
		}
	}

	function setAttentionByDay(schedule) {
		const indexDay = getDay(new Date());
		const { closed, hourFrom, hourTo } = schedule[indexDay];
		if (closed) {
			this.attention.label = CLOSE_LABEL;
			this.attention.color = this.theme.error;
		} else {
			this.setAttention({ hourFrom, hourTo });
		}
	}

	function setCommerceData() {
		const { company, settings } = this.commerce || {};
		const { comCountryId, currency } = company || {};
		this.countryPhoneCode = comCountryId && comCountryId === 2 ? '593' : '51';
		this.countryPhoneCodeComplete = comCountryId && comCountryId === 2 ? '+593' : '+51';
		this.currencySymbol = currency === 'USD' ? '$' : 'S/';
		this.token = this.commerce.tokenStore;
		this.setDataBySettings(settings);
		this.loadCategories();
		if (this.commerce.whatsappNumber) {
			this.setWhatsappNumber();
		}
	}

	function setData({ model, value }) {
		if (!model) {
			this.search = value;
		} else {
			this.form[model] = value;
		}
	}

	function setDataBySettings({ attentionHours, dailyAttentionHours, salPriceListId,
		serviceCost, shippingCost, theme, minOrderPrice, hash }) {
		this.priceMin = minOrderPrice;
		this.commerceBackground = theme ? theme.primary || this.theme.primary : this.theme.primary;
		this.delivery = Number(shippingCost) || Number(serviceCost) || 0;
		this.hash = hash;
		this.priceListId = salPriceListId;
		if (dailyAttentionHours) {
			this.setAttentionByDay(dailyAttentionHours);
		} else if (attentionHours) {
			this.setAttention(attentionHours);
		}
	}

	function setNewPrice(product, newQty) {
		if (product.priceList[this.priceListId]) {
			const ranges = product.priceList[this.priceListId].ranges;
			let newPrice = product.priceList[this.priceListId].price || 0;
			if (ranges.length > 0) {
				ranges.forEach((r) => {
					if (r.from <= newQty && newQty <= r.to) {
						newPrice = r.price || 0;
					}
				});
			}
			this.$set(product, 'price', newPrice);
		}
	}

	function setShippingType(code) {
		this[code] = true;
		if (code === 'gpsSelected') {
			const { settings } = this.commerce;
			const { shippingCost, serviceCost } = settings;
			this.delivery = Number(shippingCost) || Number(serviceCost) || 0;
			this.pickupSelected = false;
			this.getLocation();
		} else {
			this.gpsSelected = false;
			this.delivery = 0;
		}
	}

	function setWhatsappNumber() {
		const numberComplete = this.commerce.whatsappNumber.split('');
		const numberComplete2 = this.commerce.whatsappNumber.split('');
		const hasPlus = numberComplete[0] === '+';
		if (!hasPlus) {
			const digits2 = numberComplete.splice(0, 2);
			const digits3 = numberComplete2.splice(0, 3);
			const digits2Join = digits2.join('');
			const digits3Join = digits3.join('');
			this.commerce.whatsappNumber = digits2Join !== this.countryPhoneCode &&
				digits3Join !== this.countryPhoneCodeComplete ?
				`${this.countryPhoneCodeComplete}${this.commerce.whatsappNumber}` :
				this.commerce.whatsappNumber;
		}
	}

	function facebookMessage() {
		const link = document.location.href;
		return encodeURIComponent(link);
	}

	function whatsappShareMessage() {
		const link = document.location.href;
		return encodeURIComponent(link);
	}

	function showAmountMin() {
		return this.priceMin && (this.total < this.priceMin);
	}

	function showAppOption() {
		return this.showApp && this.validDevice;
	}

	function stayHere() {
		const body = document.getElementById('body');
		this.showApp = false;
		body.style = '';
	}

	function subQuantity(product) {
		if (product.quantity > 0) {
			const qtyRounded = Number((product.quantity).toFixed());
			const qty = qtyRounded < product.quantity ? qtyRounded : qtyRounded - 1;
			const isSelected = qty > 0;
			this.setNewPrice(product, qty);
			this.$set(product, 'quantity', qty);
			this.$set(product, 'isSelected', isSelected);
		}
	}

	function subtotal() {
		const productsSelected = this.completeProducts.filter(p => p.isSelected);
		return productsSelected.reduce((a, ps) => a + (ps.price * ps.quantity), 0);
	}

	function total() {
		const productsSelected = this.completeProducts.filter(p => p.isSelected);
		return productsSelected.reduce((a, ps) => a + (ps.price * ps.quantity), 0) + this.delivery;
	}

	function totalQuantity() {
		const productsSelected = this.completeProducts.filter(p => p.isSelected);
		return productsSelected.reduce((a, ps) => a + ps.quantity, 0);
	}

	function validAttention(actualHour, actualMin, fromHour, fromMin, toHour, toMin) {
		const validHours = actualHour > fromHour && actualHour < toHour;
		const validFrom = actualHour === fromHour && actualMin >= fromMin;
		const validTo = actualHour === toHour && actualMin <= toMin;
		return validHours || validFrom || validTo;
	}

	function validDevice() {
		const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
		if (reg.test(navigator.userAgent)) {
			if (this.commerce.appLink) {
				const body = document.getElementById('body');
				body.style = 'left: 0px; overflow: hidden; position: fixed; width: 100%';
				return true;
			}
			return false;
		}
		return false;
	}

	function watchLocation(value) {
		if (value.lat && value.lng) {
			this.latitude = value.lat;
			this.longitude = value.lng;
		}
		this.loading = !value.lat || !value.lng;
	}

	function whatsappLink() {
		const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
		if (reg.test(navigator.userAgent)) {
			return `https://wa.me/${this.commerce.whatsappNumber}?`;
		}
		return `https://web.whatsapp.com/send?phone=${this.commerce.whatsappNumber}&`;
	}

	function whatsappLinkShare() {
		const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
		if (reg.test(navigator.userAgent)) {
			return 'https://wa.me?';
		}
		return 'https://web.whatsapp.com/send?phone=&';
	}

	function data() {
		return {
			attention: {
				color: '',
				label: '',
			},
			categories: [],
			commerceBackground: '',
			commerce: {},
			completeProducts: [],
			countryPhoneCode: null,
			countryPhoneCodeComplete: null,
			currencySymbol: '',
			delivery: 0,
			dialog: {
				data: null,
				description: '',
				open: false,
				title: '',
			},
			form: {
				additionalInformation: '',
				address: '',
				name: '',
				paymentMethod: '',
				phone: '',
			},
			gpsSelected: false,
			hash: null,
			invalidPage: false,
			latitude: 0,
			lastPage: 0,
			loadingProducts: false,
			location: {},
			loading: false,
			longitude: 0,
			open: false,
			page: 1,
			pickupSelected: false,
			preOrder: {},
			priceListId: null,
			priceMin: null,
			products: [],
			search: '',
			showApp: true,
			theme: {},
			token: '',
			totalRegisters: null,
			whatsappMessage: null,
			whatsappNumber: null,
		};
	}

	export default {
		name: 'page-products-catalog',
		components: {
			catalogCategories,
			catalogDialog,
			catalogDialogOptions,
			catalogFooter,
			catalogHeader,
			catalogProducts,
			catalogSidebar,
		},
		computed: {
			disabled,
			facebookMessage,
			showAppOption,
			showAmountMin,
			subtotal,
			total,
			totalQuantity,
			validDevice,
			whatsappLink,
			whatsappLinkShare,
			whatsappShareMessage,
		},
		created,
		data,
		methods: {
			addProduct,
			addQuantity,
			changeValue,
			closeGallery,
			createPreOrder,
			deleteProduct,
			buildWhatsappMessage,
			changeCategory,
			clearCar,
			getLocation,
			goToApp,
			loadCategories,
			loadCommerce,
			loadProducts,
			onScroll,
			openGallery,
			openSearch,
			searchData,
			selectCategory,
			setAttention,
			setAttentionByDay,
			setCommerceData,
			setData,
			setDataBySettings,
			setNewPrice,
			setShippingType,
			setWhatsappNumber,
			stayHere,
			subQuantity,
			validAttention,
		},
		props: {
			commerceCode: [String, Number],
		},
		watch: {
			location: {
				deep: true,
				handler: watchLocation,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container-catalog {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		padding: 80px 15px 0px;
		scroll-behavior: smooth;

		&-min {
			padding: 118px 15px 0px;
		}

		@media (min-width: 936px) {
			max-height: calc(100vh - 127px);
			padding: 145px 15px 0px;
		}

		@media (min-width: 1200px) {
			padding: 138px 0px;
		}
	}

	.catalog-column {
		display: inline-flex;
		flex: 1 1 auto;

		&.catalog-column-left {
			@media (min-width: 740px) {
				max-width: calc(100% - 346px);
				padding-right: 25px;
			}

			@media (min-width: 936px) {
				margin-bottom: 84px;
			}
		}

		&.catalog-column-right {
			margin-bottom: 15px;
			max-width: 100%;

			@media (min-width: 740px) {
				max-width: 346px;
				padding-bottom: 84px;
			}
		}
	}

	.catalog-empty {
		align-items: center;
		bottom: 0px;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		font-weight: weight(bold);
		height: 100vh;
		justify-content: center;
		left: 0px;
		position: fixed;
		right: 0px;
		text-align: center;
		top: 0px;
		width: 100vw;

		p {
			font-size: size(large30);

			&:first-of-type {
				font-size: size(big);
			}
		}
	}

	.content-block {
		padding-bottom: 56px;
		padding-top: 78px;

		@media (min-width: 936px) {
			padding-bottom: 84px;
			padding-top: 128px;
		}
	}

	.container-categories {
		left: 0;
		position: fixed;
		right: 0;
		width: 100%;
		z-index: 1;
	}
</style>


// WEBPACK FOOTER //
// src/pages/page-products-catalog.vue